import { render, staticRenderFns } from "./HealthHacksItemDetailView.vue?vue&type=template&id=1c4bd268&"
import script from "./HealthHacksItemDetailView.vue?vue&type=script&lang=js&"
export * from "./HealthHacksItemDetailView.vue?vue&type=script&lang=js&"
import style0 from "./HealthHacksItemDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports